import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';
import { TaskItemStateEnum } from '../../../home-data/home-data.data';

export const SCHEMA = Object.freeze({
  LIST_IDENTIFIER: '',
  LIST_STATE: TaskItemStateEnum,
});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class TaskTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.task_list;
  }

  get properties() {
    return this.toJS();
  }
}
